import React from 'react';


class TwoTwoFiveSevenPage extends React.Component {
  render() {
    return (
      <div id="application">
        <div className="content flex flex-1">
          <div className="container">
            <p className="h1">
              18 U.S.C. 2257 Record-Keeping Requirements
              Compliance Statement
            </p>
            <p>
              This website contains nudity but does not contain
              sexually-explicit conduct.
            </p>
            <p>
              All models, actors, actresses and other persons that
              appear on NakedNews.com were over the age of 18 at
              the time of the creation of the video or content
              displayed.
            </p>
            <p>
              The custodian of records: Egalaxy Multimedia Inc., Attn: M. Thibodeau, 2133 Danforth Avenue, Suite 195, Toronto ON, M4C 1K2, Canada
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default TwoTwoFiveSevenPage;
